import { render, staticRenderFns } from "./VaFileUpload.vue?vue&type=template&id=337a7295&"
import script from "./VaFileUpload.vue?vue&type=script&lang=js&"
export * from "./VaFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./VaFileUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports